<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" size="medium">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            :label="
              $l('table_label_template_attachment_name') || '模版附件名称'
            "
            prop="templateAttachmentName"
          >
            <el-input
              clearable
              filterable
              maxlength="20"
              v-model="formData.templateAttachmentName"
              type="text"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-form-item
          :label="$l('INDEX.order_form_btn_select_file') || '选择文件'"
          required
        >
          <el-col :span="24">
            <el-upload
              drag
              :multiple="multipleDisabled"
              :auto-upload="false"
              :on-change="onFileChange"
              :on-remove="onFileRemove"
              action="/oss/ossUploadReturnUrlAndFileId"
              ><i class="el-icon-upload"></i>
              <div class="el-upload__text">
                {{ $l('INDEX.file_upload_tips_first') || '将文件拖到此处，或'
                }}<em>
                  {{ $l('INDEX.file_upload_tips_last') || '点击上传' }}
                </em>
              </div>
              <div slot="file" slot-scope="{ file }">
                <a
                  style="text-decoration: none;margin-right:50px"
                  class="el-upload-list__item-name"
                >
                  <i class="el-icon-document"></i>
                  {{ file.name }}
                </a>
                <i
                  class="el-icon-folder-opened mr-4"
                  @click="onFilePreview(file)"
                ></i>
                <i class="el-icon-close" @click="onFileDelete(file)"></i>
              </div>
            </el-upload>
          </el-col>
        </el-form-item>
      </el-row>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.product_dialog_btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    multipleDisabled: { type: Boolean, default: false },
    templateCode: { type: String, default: '' },
  },
  data() {
    return {
      backDialogVisible: false,
      formData: {},
      rules: {
        templateAttachmentName: [
          {
            required: true,
            message:
              this.$l('tips_please_enter_template_attachment_name') ||
              '请输入模版附件名称',
            trigger: 'blur',
          },
        ],
      },
    }
  },

  methods: {
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      if (!this.listFile || !this.listFile.length) {
        this.$message.warning(
          this.$l('tips_please_select_template_attachment') ||
            `请选择您需要上传的模板附件！`
        )
        return
      }
      const list = this.listFile.filter((f) => f.size / 1024 / 1024 > 10)

      if (list.length > 0) {
        this.$confirm(
          '部分文件大小超过10M，是否过滤这些文件并保存？',
          this.$l('INDEX.label_completeDesc') || '确认信息',
          {
            confirmButtonText:
              this.$l('INDEX.product_dialog_btn_confirm') || '确定',
            cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
            type: 'warning',
          }
        )
          .then(() => {
            list.forEach((e) => {
              const index = this.getIndexByFileUID(e.uid)
              this.listFile.splice(index, 1)
            })
            this.confirmSave()
          })
          .catch(() => {
            return
          })
      } else {
        this.confirmSave()
      }
      // const listAttachment = await this.uploadFiles(this.listFile)
      // const data = {
      //   listAttachment: listAttachment,
      //   templateAttachmentName: this.formData.templateAttachmentName,
      // }
      // if (this.templateCode) {
      //   this.loadingOpen()
      //   this.$api
      //     .sysInoutTemplateAttachmentSaveApi({
      //       templateAttachmentName: this.formData.templateAttachmentName,
      //       templateCode: this.templateCode,
      //       ...listAttachment[0],
      //     })
      //     .then((res) => {
      //       this.loadingClose()
      //       const { status } = res
      //       if (status !== 200) {
      //         this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
      //         return
      //       }
      //       this.$message({
      //         showClose: true,
      //         message: this.$l('INDEX.tips_save_ok') || '保存成功！',
      //         type: 'success',
      //       })
      //       this.$emit('reload')
      //       this.$emit('close')
      //     })
      //     .catch(() => {
      //       this.loadingClose()
      //       this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
      //     })
      // } else {
      //   this.$emit('updateTableData', data)
      // }
    },
    async confirmSave() {
      if (!this.listFile || !this.listFile.length) {
        this.$message.warning(
          this.$l('tips_please_select_template_attachment') ||
            `请选择您需要上传的模板附件！`
        )
        return
      }
      this.loadingOpen()
      const listAttachment = await this.uploadFiles(this.listFile)
      const data = {
        listAttachment: listAttachment,
        templateAttachmentName: this.formData.templateAttachmentName,
      }
      if (this.templateCode) {
        // this.loadingOpen()
        this.$api
          .sysInoutTemplateAttachmentSaveApi({
            templateAttachmentName: this.formData.templateAttachmentName,
            templateCode: this.templateCode,
            ...listAttachment[0],
          })
          .then((res) => {
            this.loadingClose()
            const { status } = res
            if (status !== 200) {
              this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
              return
            }
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功！',
              type: 'success',
            })
            this.$emit('reload')
            this.$emit('close')
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          })
      } else {
        this.$emit('updateTableData', data)
        this.loadingClose()
      }
    },
    uploadFiles(listFile) {
      if (!listFile || !listFile.length) {
        return Promise.resolve([])
      }
      const uploadTask = listFile.map((file) => {
        return this.$api.SYS_UPLOAD(file.raw).then((res) => ({
          templateAttachmentFileCode: res.body.fileId,
          templateAttachmentFileUrl: res.body.url,
          templateAttachmentFileName: file.name,
          templateAttachmentFileType: file.name.substring(
            file.name.lastIndexOf('.') + 1
          ),
        }))
      })
      return Promise.all(uploadTask)
    },
    onFilePreview(file) {
      const url = URL.createObjectURL(file.raw)
      window.open(url)
    },
    onFileDelete({ uid }) {
      const index = this.getIndexByFileUID(uid)
      this.listFile.splice(index, 1)
    },
    onFileChange(file, fileList) {
      if (!this.multipleDisabled) {
        if (fileList.length > 1) {
          fileList.splice(0, 1)
        }
      }
      this.listFile = fileList
    },
    onFileRemove(file, fileList) {
      this.listFile = fileList
    },
    getIndexByFileUID(uid) {
      const index = this.listFile.findIndex((file) => {
        return uid == file.uid
      })
      return index
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
a:hover {
  color: #409eff;
  text-decoration: none;
}

.el-upload-list__item .el-icon-folder-opened {
  display: none;
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  opacity: 0.75;
  color: #606266;
}

.el-upload-list__item:hover {
  .el-icon-folder-opened {
    display: inline-block;
  }
}

// 重写element 样式
::v-deep {
  .el-upload-dragger {
    width: 478px;
  }
}
</style>
